import { IFormNormalizedOption, IFormOption } from '~/types/form'

export const onMaskPhone = (oldValue: string) => {
  if (!oldValue) return ''

  const values = oldValue.replaceAll(/\D/g, '')

  if (values.length <= 2) {
    const x = values.match(/(\d{0,2})/)
    return x ? `${x[1]}` : ''
  } else if (values.length < 10) {
    const x = values.match(/(\d{0,2})(\d{0,4})(\d{0,4})/)
    return x ? `(${x[1]}) ${x[2]}${x[3] ? '-' + x[3] : ''}` : ''
  } else
    switch (values.length) {
      case 10: {
        const x = values.match(/(\d{0,2})(\d{0,4})(\d{0,4})/)
        return x ? `(${x[1]}) ${x[2]}-${x[3]}` : ''
      }
      case 11: {
        const x = values.match(/(\d{0,2})(\d{0,5})(\d{0,4})/)
        return x ? `(${x[1]}) ${x[2]}-${x[3]}` : ''
      }
      case 12: {
        const x = values.match(/(\d{0,2})(\d{0,2})(\d{0,4})(\d{0,4})/)
        return x ? `+${x[1]} ${x[2]} ${x[3]}-${x[4]}` : ''
      }
      default: {
        const x = values.match(/(\d{0,2})(\d{0,2})(\d{0,5})(\d{0,12})/)
        return x ? `+${x[1]} ${x[2]} ${x[3]}-${x[4]}` : ''
      }
    }
}

const transformStringToOption = (
  formName: string,
  option: string,
  index: number
): IFormNormalizedOption => {
  const valueKey = option.toLowerCase().replaceAll(' ', '-')
  const id = `${formName}-${valueKey}-${index}`

  return {
    id,
    value: option,
    label: option,
  }
}

export const normalizeSelectOptions = (
  formName: string,
  options: string[] | IFormOption[]
): IFormNormalizedOption[] => {
  return options.map((option, index) => {
    if (typeof option === 'object') {
      return {
        ...option,
        id: option.id
          ? `${formName}-${option.id}`
          : `${formName}-${option.value}-${index}`,
      }
    }
    return transformStringToOption(formName, option, index)
  })
}
